import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { trackPageView } from "@/lib/tracking";

const RouteEffects = () => {
  const { pathname } = useLocation();
  const mounted = useRef(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!mounted.current) {
      mounted.current = true;
      return; // 首次加载的 PageView 由 Pixel base code 触发
    }
    trackPageView(pathname);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteEffects />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
